'use strict';

let requireOrNull;
if (process.env.WEBPACK) {
  requireOrNull = require;
} else {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'EventPipe',
    module: requireOrNull('../../../../modules/deal/frontend/event_pipe'),
  },
  {
    name: 'BuyButton',
    module: requireOrNull(
      '../../../../modules/buy_button/desktop_2016/frontend/buy_button'
    ),
  },
  {
    name: 'MultiOptionModal',
    module: requireOrNull(
      '../../../../modules/buy_button/desktop_2016/frontend/multi_option_modal'
    ),
  },
  {
    name: 'Carousel',
    module: requireOrNull('../../../../modules/carousel/frontend/desktop'),
  },
  {
    name: 'StickyPurchaseCluster',
    module: requireOrNull(
      '../../../../modules/deal/desktop_2016/frontend/sticky_purchase_cluster'
    ),
    featureCheck: serverObj => serverObj.stickySidebar,
  },
  {
    name: 'Discount',
    module: requireOrNull('../../../../modules/discount/frontend/index'),
  },
  {
    name: 'Variations',
    module: requireOrNull(
      '../../../../modules/variations/frontend/variations-widget'
    ),
    featureCheck: serverObj => serverObj.variations,
  },
  {
    name: 'DealHighlights',
    module: requireOrNull(
      '../../../../modules/deal_highlights/frontend/deal_highlights'
    ),
    featureCheck: serverObj => serverObj.dealHighlights,
  },
];

const nonCritModules = [
  {
    name: 'DealLazyLoader',
    module: requireOrNull('../../../../modules/deal/frontend/deal_lazy_loader'),
  },
  {
    name: 'Gift',
    module: requireOrNull('../../../../modules/gift_button/frontend/gift'),
  },
  {
    name: 'Wishlist',
    module: requireOrNull(
      '../../../../modules/wishlist_button/frontend/wishlist'
    ),
    featureCheck: serverObj => serverObj.wishlist,
  },
  {
    name: 'ChannelTabs',
    module: requireOrNull('../../../../modules/deal/frontend/channel_tabs'),
  },
  {
    name: 'ExternalLinks',
    module: requireOrNull('../../../../modules/deal/frontend/external_links'),
  },
  {
    name: 'ExternalDeal',
    module: requireOrNull(
      '../../../../modules/external_deal/frontend/external_deal'
    ),
    featureCheck: serverObj => serverObj.externalDeal,
  },
  {
    name: 'Sharing',
    module: requireOrNull('../../../../modules/sharing/frontend/facebook'),
  },
  {
    name: 'MemberOnly',
    module: requireOrNull('../../../../modules/member_only/frontend/main'),
    featureCheck: serverObj => serverObj.memberOnly,
  },
  {
    name: 'FixAlly',
    module: requireOrNull('../../scripts/vendor_modules/fix-a11y'),
  },
];

const pageReadyModules = [
  {
    name: 'pageReady',
    module: requireOrNull('../../../../modules/deal/frontend/page_ready'),
  },
];

module.exports = { critModules, nonCritModules, pageReadyModules };
